"use client"

import { Logs } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LogsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LogsIcon = component(Icon)({ as: Logs })
